import ToggleButtonGroup, {
  ToggleOption,
} from '../../../../components/Forms/Buttons/ToggleButtonGroup';
import SearchInputField from '../../../../components/Forms/Input/SearchInputField';

export type MenuCategoryStatusFilter = 'ALL' | 'ACTIVE' | 'INACTIVE';

interface MenuCategoryFiltersProps {
  search: string;
  status: MenuCategoryStatusFilter;
  onSearchChange: (value: string) => void;
  onStatusChange: (value: MenuCategoryStatusFilter) => void;
}

const statusOptions: ToggleOption<MenuCategoryStatusFilter>[] = [
  {
    value: 'ALL',
    label: 'Todas',
  },
  {
    value: 'ACTIVE',
    label: 'Activas',
  },
  {
    value: 'INACTIVE',
    label: 'Inactivas',
  },
];

const MenuCategoryFilters = ({
  search,
  status,
  onSearchChange,
  onStatusChange,
}: MenuCategoryFiltersProps) => {
  return (
    <div className="flex flex-col gap-4 border-b border-stroke px-5 py-4 dark:border-strokedark lg:flex-row lg:items-center lg:justify-between">
      <div className="w-full lg:max-w-md">
        <SearchInputField
          name="searchMenuCategory"
          value={search}
          placeholder="Buscar categoría..."
          withMargin={false}
          onChange={(event) => onSearchChange(event.target.value)}
        />
      </div>

      <ToggleButtonGroup
        value={status}
        options={statusOptions}
        onChange={onStatusChange}
      />
    </div>
  );
};

export default MenuCategoryFilters;
